import { ObjectField, NoPointers, Int32Field, ArrayField, } from "@opendaw/lib-box";
export class CubedPattern extends ObjectField {
    static create(construct) {
        return new CubedPattern(construct);
    }
    constructor(construct) {
        super(construct);
    }
    get length() {
        return this.getField(1);
    }
    get steps() {
        return this.getField(2);
    }
    initializeFields() {
        return {
            1: Int32Field.create({
                parent: this,
                fieldKey: 1,
                fieldName: "length",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 1, max: 64 }, "", 16),
            2: ArrayField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "steps",
                deprecated: false,
                pointerRules: NoPointers,
            }, (construct) => Int32Field.create(construct, "any", "", 60), 64),
        };
    }
}
